module.exports = __webpack_public_path__ + "static/media/niwLogo.2b924bb4.png";